import { FIELD_TYPES } from 'src/tpbp-core/models/fields/field-set.const'
import type {
  FieldInterface,
  RelationInterface,
} from 'src/tpbp-configuration/mapper/mappingInterfaces'
import { FIELD_RULES } from 'src/tpbp-core/models/fields/fieldRules.const'

const personConfigurationFields: FieldInterface[] = [
  {
    key: 'creationType',
    originKey: 'creation_type',
    type: FIELD_TYPES.string,
    rule: FIELD_RULES.isReadOnly,
  },
  {
    key: 'dependentObjects',
    originKey: 'dependent_objects',
    type: FIELD_TYPES.object,
    rule: FIELD_RULES.isReadOnly,
  },
  {
    key: 'schema',
    originKey: 'schema',
    type: FIELD_TYPES.object,
    rule: FIELD_RULES.isReadOnly,
  },
  {
    key: 'additionalRules',
    originKey: 'additional_rules',
    type: FIELD_TYPES.object,
    rule: FIELD_RULES.isReadOnly,
  },
]

const personConfigurationRelations: RelationInterface[] = []

export { personConfigurationFields, personConfigurationRelations }
